import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';import { Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { Form, FormCategory, FormUploadVM, SearchByParametersVM, StateVM, UsersVM, VMFormSearch } from '../perform-induction/perform-induction';
import { SafetyInductionService } from '../services/safety-induction.service';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { OrdinalDateParse } from '../adapters/ordinal-date-adapter';
import { SelectionLists } from '../../../entities';
import { PreferencesService } from '../../preferences/preferences.service';
import { NotificationsService } from 'angular2-notifications';
import { DeleteFormsConfirmationDialogComponent } from './delete-forms-confirmation-dialog/delete-forms-confirmation-dialog.component';

const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'll',
  },
  display: {
    locale: 'en-au',
    dateInput: 'll',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'll',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
@Component({
  selector: 'app-search-form-analysisreporting',
  templateUrl: './search-form-analysisreporting.component.html',
  styleUrls: ['./search-form-analysisreporting.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})
export class SearchFormAnalysisreportingComponent implements OnInit {

  constructor(
    private _router: Router,
    private _appService: AppService,
    private _inductionService: SafetyInductionService,
    public dialog: MatDialog, private readonly _pref: PreferencesService,
    private _notify: NotificationsService,
    
  ) { }
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  ord: OrdinalDateParse = new OrdinalDateParse();
  StartDate: Date = new Date(

    new Date().getFullYear(),
    new Date().getMonth()-1,
    new Date().getDate()
  );
  EndDate= new Date();
  DueDateEnd: Date;
  DueDateStart: Date;
  CategoryList: FormCategory[];
  FormList: Form[];
  FormList_: Form[];
  RelatedUserList: UsersVM[];
  CopyRelatedUserList: UsersVM[];
  ResponsibleUserList: UsersVM[];
  CopyResponsibleUserList: UsersVM[];

  RelatedUserListUnfiltered: UsersVM[];
  SelectedCategory: number = 0;
  SelectedForm: number = 0;
  SelectdRelatedUser: number = 0;
  FollowUpRequired: boolean = false;
  FollowUpCompleted: boolean = false;
  SuspendedUsers:boolean=false;
  SearchResultFormList: FormUploadVM[];
  SearchResultFormList_: FormUploadVM[];
  SearchResultFormListnotsorted: FormUploadVM[];
  isLoading: boolean = false;
  SelectdState: number = 0;
  Sites: StateVM[];
  SelectdPersonResponsible: number = 0
  selectedCustomer:number[]=[];

  ArchivedForms: boolean = false;
  ActiveForms: boolean = true;

  ngOnInit() {

    this._appService.setPageTitle('Form Seach');
    this._inductionService.GetFormSearch().subscribe(res => {
      console.log("GetFormSearch", res)
      let result: VMFormSearch = res;
      this.CategoryList = result.FormCategories
      this.FormList = result.Forms;
      this.FormList_ = result.Forms;

      if(result.Forms != null && result.Forms.length>0){

        let frm = []

        result.Forms.map(m=>{
          if(m.Name){
            frm.push(m)
          }
        })

        this.FormList=frm.sort(function(a, b){
          if(a.Name < b.Name) { return -1; }
          if(a.Name > b.Name) { return 1; }
          return 0;
      })

      this.FormList_=frm.sort(function(a, b){
        if(a.Name < b.Name) { return -1; }
        if(a.Name > b.Name) { return 1; }
        return 0;
    })
      }

      this.RelatedUserList = result.Users
      

      let _FormCat = new FormCategory();
      _FormCat.Name = "All"
      _FormCat.ID = 0
      this.CategoryList.unshift(_FormCat)

      let _Form = new Form();
      _Form.Name = "All"
      _Form.ID = 0;
      this.FormList.unshift(_Form)

      let _user = new UsersVM();
      _user.UserName = "All"
      _user.UserId = "0";
      _user.UserAuto = 0;
      _user.suspended = false;


      this.RelatedUserList.unshift(_user)
      this.RelatedUserListUnfiltered=this.RelatedUserList
      let _usrList = this.RelatedUserList

      if(this.SuspendedUsers == false){
        this.RelatedUserList = _usrList.filter(f=>f.suspended==false);
        this.CopyRelatedUserList = this.RelatedUserList;
        this.ResponsibleUserList = this.RelatedUserList;
        this.CopyResponsibleUserList = this.RelatedUserList;

      }else{
        this.RelatedUserList = _usrList
        this.CopyRelatedUserList = _usrList;
        this.ResponsibleUserList = _usrList;
        this.CopyResponsibleUserList = _usrList;
      }
      

      let _state = new StateVM();
      _state.ID = 0
      _state.SideCode = "All";
      this.Sites = result.States
      this.Sites.unshift(_state)
    })

    this._appService.getCustomerListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.customerList = result;
        this._dropDownListsFiltered.customerList = result;
        console.log( " this._dropDownLists.customerList ",this._dropDownLists.customerList )
      },
      error => {
        console.error(error);
      },
      () => {
        
      }
    );
  }


  ChangeSuspendedUsers(checked){
    console.log("ChangeSuspendedUsers",checked)
    console.log("this.SearchResultFormList_",this.SearchResultFormList_)

if(checked){

//TT-5707
// this.RelatedUserList=[]
 this.RelatedUserVal=""
this.SelectdRelatedUser = 0;
this.RelatedUserList = this.RelatedUserListUnfiltered.filter(f=>f.suspended == true)
if(this.SearchResultFormList_!=undefined){
  this.SearchResultFormList= this.SearchResultFormList_.filter(f=>f.suspended==true)}
//

//this.RelatedUserList = this.RelatedUserListUnfiltered
this.CopyRelatedUserList = this.RelatedUserList;
this.ResponsibleUserList = this.RelatedUserList;
this.CopyResponsibleUserList = this.RelatedUserList;
}else{

//TT-5707
// this.RelatedUserList=[]
 this.RelatedUserVal=""
this.SelectdRelatedUser = 0;
if(this.SearchResultFormList_!=undefined){
  this.SearchResultFormList= this.SearchResultFormList_.filter(f=>f.suspended==false)
}

//

  let usrs= this.RelatedUserListUnfiltered.filter(f=>f.suspended == false)
  this.RelatedUserList =usrs
this.CopyRelatedUserList = this.RelatedUserList;
this.ResponsibleUserList = this.RelatedUserList;
this.CopyResponsibleUserList = this.RelatedUserList;

  console.log("usrs",usrs)
}



  }


  changeCategory(val) {

  }

  changeForm(val) {

  }

  changeRelatedUser(val) {

  }

  

  dateChanged() { }

  onNoClick() { }

  onClickOpenForm(form) {
    if (form.IsDigitalForm) {
      //this._router.navigate(['/editdigitalformscomponent', form.Id]);
    //  window.open('/editdigitalformscomponent/' + form.Id, '_blank');

    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate(['/editdigitalformscomponent', form.Id]);
      }else{             
        window.open('/editdigitalformscomponent/' + form.Id, '_blank');
       
      }
  });


    } else {
      //this._router.navigate(['/uploadformedit', form.Id]);
   //   window.open('/uploadformedit/' + form.Id, '_blank');

   this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate(['/uploadformedit', form.Id]);
    }else{             
      window.open('/uploadformedit/' + form.Id, '_blank');
     
    }
});

    }
  }

  onClickDownloadForm(form) {
    this._inductionService.GetFormFileData(form.Id).subscribe(msg => {
      var newstring = msg.slice(1);
      console.log('length ', newstring.length - 1)

      let _newstring = newstring.substring(0, newstring.length - 1);

      console.log("newstringnewstringnewstring", _newstring)

      var arrBuffer = this.base64ToArrayBuffer(msg);

      var blob = new Blob([arrBuffer], { type: 'application/pdf' });
      //const linkSource = `data:application/pdf;base64,${msg}`;
      var link = document.createElement('a');
      //const fileName = "vct_illustration.pdf";

      link.href = window.URL.createObjectURL(blob);
      link.download = form.FileName + '.pdf';
      link.click();
    })
  }

  base64ToArrayBuffer(base64) {
    console.log("base64", base64)
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  changeState(val) {

  }

  SitesChanged(val) {
    
    this.SelectdState = val.value
  }

  RelatedUserChanged(val) {
    this.SelectdRelatedUser = val.value
  }
  
  CategoryChanged(val) {
    console.log("this.FormList_",this.FormList_)
    console.log("val",val.value)
    let fr = this.FormList_
    let tempArr :Form[]=[];

  
      if(val.value >0){
      
       // val.value.map(m=>{
        //  if(m){
            let _catA = fr.filter(d=>d.FormCategoryID==val.value)
            console.log("_workAfiltered by dep",_catA)
            if(_catA){
              this.FormList = _catA
            }
            
         // }
      // })
      
      }
      else
        this.FormList=this.FormList_

  }

  FormChanged(val) {
    this.SelectedForm = val.value
  }

  PersonResponsibleChanged(val) {
    this.SelectdPersonResponsible = val.value
  }



  onSearch() {

    let _StartDate =this.StartDate? this.ord.formatDateOrdinal((this.StartDate.toString())
      .split(' ')
      .slice(1)
      .join(' '), false):this.StartDate;
    let _EndDate = this.EndDate?this.ord.formatDateOrdinal((this.EndDate.toString())
      .split(' ')
      .slice(1)
      .join(' '), false):this.EndDate;


    this.isLoading = true


    let params = new SearchByParametersVM();
    params.DateCompletedEnd =_EndDate;//moment(this.EndDate).format('DD/MM/YYYY')
    params.DateCompletedStart = _StartDate; //moment(this.StartDate).format('DD/MM/YYYY')
    params.FormCategory = this.SelectedCategory
    params.RelatedUser = this.SelectdRelatedUser
    params.FollowUpRequired = this.FollowUpRequired
    params.FollowUpCompleted = this.FollowUpCompleted
    params.Form = this.SelectedForm
    params.StateId = this.SelectdState
    params.PersonResponsible = this.SelectdPersonResponsible
    params.DueDateStart = this.DueDateStart ?this.DueDateStart:null// moment(this.DueDateStart).format('DD/MM/YYYY') : ""
    params.DueDateEnd = this.DueDateEnd ? this.DueDateEnd:null//moment(this.DueDateEnd).format('DD/MM/YYYY') : ""

      //TT-5923
    if(this.ArchivedForms==true && this.ActiveForms==true){
      params.isArchived=this.ArchivedForms
      params.isActive=this.ActiveForms
    }
    if(this.ArchivedForms==false && this.ActiveForms==false){
      params.isArchived=true
      params.isActive=true
    }
    if(this.ArchivedForms==true && this.ActiveForms==false){
      params.isArchived=true
      params.isActive=false
    }
    if(this.ArchivedForms==false && this.ActiveForms==true){
      params.isArchived=false
      params.isActive=true
    }
    
  
   
    // if(this.selectedCustomer.length==0){
    //   this._dropDownLists.customerList.map(x=>{
    //     this.selectedCustomer.push(x.Id);
    //   });
    // }
    params.selectedCustomerId=this.selectedCustomer.length>0 ? this.selectedCustomer:this.selectedCustomer
    
    this._inductionService.SearchByParameters(params).subscribe(res => {
      
    // this.SearchResultFormList = res;
     if(this.SuspendedUsers ==true){
      this.SearchResultFormList = res.filter(f=>f.suspended==true);
      this.SearchResultFormList_ = res.filter(f=>f.suspended==true);
     }
     else{
      this.SearchResultFormList = res.filter(f=>f.suspended==false);
      this.SearchResultFormList_ = res.filter(f=>f.suspended==false);

     }
     //this.SearchResultFormListnotsorted=res;
      this.isLoading = false

      //TT-5059
    //   this.SearchResultFormList = this.SearchResultFormListnotsorted.sort((a,b) => {
    //     if(a.userName < b.userName) { return -1; }
    //     if(a.userName > b.userName) { return 1; }
    // })
    })
  }

  DueDateEndChanged(event) {
    // console.log('b' + event);
    this.DueDateEnd =  new Date(event);

  }

  DueDateStartChanged(event) {
    // console.log('b' + event);
    this.DueDateStart =  new Date(event);

  }

  StartDateChanged(event) {
    // console.log('b' + event);
    this.StartDate =  new Date(event);

  }

  EndDateChanged(event) {
    // console.log('b' + event);
    this.EndDate =  new Date(event);

  }

  onResetClick() {
    this.EndDate = new Date();
    this.StartDate= new Date(

      new Date().getFullYear(),
      new Date().getMonth() - 1,
      new Date().getDate()
    );
    this.DueDateEnd = null
    this.DueDateStart = null
    this.SelectedCategory = 0;
    this.SelectedForm = 0;
    this.SelectdRelatedUser = 0;
    this.FollowUpRequired = false;
    this.FollowUpCompleted = false;
    this.RelatedUserListUnfiltered=[]
    this.RelatedUserList=[]
    this.ResponsibleUserList=[]

    this.SuspendedUsers=false
    this.SelectdState = 0;
    this.SelectdPersonResponsible = 0
    this.SearchResultFormList = []
    this.selectedCustomer=[];
    this.PersonResVal="";
    this.RelatedUserVal=""
    this.RelatedUserList = this.CopyRelatedUserList;
    this.ResponsibleUserList = this.CopyResponsibleUserList;
  }

  relatedUserTitle:String ="All";
  relatedUserId_:number=0;
  RelatedUserVal:string;
  changeRelatedUserAutoComplete(event){
    this.relatedUserId_ =0;
    this.SelectdRelatedUser=0;
    const filterValue = event.target.value.toLowerCase();
   
    let has = this.CopyRelatedUserList.find(option => option.UserName.toLowerCase().includes(filterValue.toString()));

    this.RelatedUserList = this.CopyRelatedUserList.filter(option => option.UserName.toLowerCase().includes(filterValue.toString()));
    console.log("value", filterValue, this.RelatedUserList)
  }


  relateduserselect(relateduserid) {
     this.SelectdRelatedUser =this.RelatedUserList.find(f=>f.UserName.toLowerCase() == relateduserid.toString().toLowerCase()).UserAuto;
     this.relatedUserId_ = this.RelatedUserList.find(f=>f.UserName.toLowerCase() == relateduserid.toString().toLowerCase()).UserAuto;
    
    console.log("relatedUserId_", this.relatedUserId_, this.SelectdRelatedUser)
    
  }


  
  resposiblepersonTitle:String ="All";
  resposiblepersonId_:number=0;
  PersonResVal:string;
  changeResposiblePersonAutoComplete(event){
    this.resposiblepersonId_ =0;
    this.SelectdPersonResponsible=0;
    const filterValue = event.target.value.toLowerCase();
    console.log("value____", filterValue, this.CopyResponsibleUserList)

    this.ResponsibleUserList = this.CopyResponsibleUserList.filter(option => option.UserName.toLowerCase().includes(filterValue.toString()));
    console.log("value", filterValue, this.CopyResponsibleUserList)
  }


  ResposiblePersonselect(relateduserid) {
     this.SelectdPersonResponsible =this.ResponsibleUserList.find(f=>f.UserName.toLowerCase() == relateduserid.toString().toLowerCase()).UserAuto;
     this.resposiblepersonId_ = this.ResponsibleUserList.find(f=>f.UserName.toLowerCase() == relateduserid.toString().toLowerCase()).UserAuto;
    
    console.log("relatedUserId_", this.relatedUserId_, this.SelectdRelatedUser)
    
  }


  // AddtoArchive(form){
  //  form.isArchived=!form.isArchived
  //  this._inductionService.AddtoArchive(form.Id, form.isArchived).subscribe(res=>{
  //    if(res==true){
  //     this._notify.success("Form Added to Archive")
  //    }else this._notify.error("Error saving Form to Archive")
  //    })

  // }


  

  AddtoArchive(form){
    form.isArchived=!form.isArchived
      this._inductionService.AddtoArchive(form.Id, form.isArchived).subscribe(res=>{
        if(res==true){
          if(form.isArchived==true){
            this._notify.success("Form Added to Archive")
          }else{
            this._notify.success("Form/s now Active")
          }
        
        }else this._notify.error("Error saving Form to Archive")
        }) 

}

  cbAllFormsSelect: boolean = false;
  toggleAllForms(v) {
    console.log("rrr",v)
    this.SearchResultFormList.forEach(c2 => c2.isArchived = v);
    const addSectionDialog = this.dialog.open(DeleteFormsConfirmationDialogComponent, {

      disableClose:true,
      data: {
        IsAddtoArchive: v,
      }
        //isClose:false
      });
      addSectionDialog.afterClosed().subscribe(res => {
        if (res == true) {
           // this.componentList.forEach(c => c.Selected = v);
    
    this.saveAllArchivedForms(this.SearchResultFormList)
        }
      });

  
}

saveAllArchivedForms(archivedList:FormUploadVM[]){
  this._inductionService.saveAllArchivedForms(archivedList).subscribe(res=>{
    if(res==true){
      this._notify.success("Forms Added to Archive")
    }
    else this._notify.error("Error saving Form to Archive")
  })
}


DownloadCSVFile() {
  const headerRow: string[] = ['Date', 'Category', 'Form', 'Related User', 'Incident Type', 'Date Due', 'Person Responsible', 'Form Type','Archive'];
  const csvData: any[] = [];

  // Adding table data to the csvData array
  for (const sr of this.SearchResultFormList) {
    const row: any[] = [
      sr.CompletedDate,
      sr.FormCatName,
      sr.FormName,
      sr.userName,
      sr.IncidentTypeName,
      sr.FollowUpDate,
      sr.FollowUpUserName,
      sr.IsDigitalForm ? 'Digital' : 'PDF',
      sr.isArchived ? 'Yes' : 'No'
    ];
    csvData.push(row);
  }

  // Creating a CSV string
  let csvString = headerRow.join(',') + '\n';
  csvData.forEach((row: any[]) => {
    csvString += row.join(',') + '\n';
  });

  // Creating a temporary link and downloading the file
  const a = document.createElement('a');
  a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvString);
  a.download = 'Search Forms.csv';
  a.click();
}

}
